import React from 'react';
import { BASE_URL } from '../../constant/api';

function AdminProductFeedbackCard({ feedback }) {

    // Format the date from created_at (DD/MM/YYYY style)
    const formattedDate = new Date(feedback.created_at).toLocaleDateString('en-GB');

    return (
        <div className="relative bg-white rounded-lg shadow p-4 flex space-x-4">
            {/* Seller badge (top-left). Adjust positioning to taste. */}
            <div className="absolute top-2 left-2 bg-black text-white opacity-50 text-xs px-2 py-1 rounded">
                {feedback.seller_name || "UNKNOWN"}
            </div>

            {/* Product image */}
            {feedback.product_image && (
                <img
                    src={`${BASE_URL}${feedback.product_image}`}
                    alt={feedback.product_name}
                    className="w-24 h-full object-contain rounded"
                />
            )}

            {/* Card content */}
            <div className="flex flex-col justify-between w-full">
                {/* Product name */}
                <h2 className="text-lg font-semibold text-gray-800  mb-1">
                    {feedback.product_name}
                </h2>

                {/* Customer, date, location row */}
                <div className="text-sm text-gray-600 flex items-center justify-between mb-2 space-x-2">
                    <span>{feedback.user}</span>
                    <div className='flex gap-2'>
                        <span>{formattedDate}</span>
                        {/* Hard-coded location from your example screenshot */}
                        <span>Kochi</span>
                    </div>
                </div>

                {/* Rating */}
                <div className="flex items-center mb-2">
                    <div className="flex">
                        {Array.from({ length: 5 }, (_, i) => (
                            <svg
                                key={i}
                                className={`h-4 w-4 ${i < feedback.rating ? 'text-yellow-500' : 'text-gray-300'
                                    }`}
                                fill="currentColor"
                                viewBox="0 0 20 20"
                            >
                                <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.264 3.866a1 1 0 00.95.69h4.065c.969 0 1.371 1.24.588 1.81l-3.297 2.397a1 1 0 00-.363 1.118l1.264 3.866c.3.921-.755 1.688-1.54 1.118l-3.297-2.397a1 1 0 00-1.176 0l-3.297 2.397c-.784.57-1.838-.197-1.539-1.118l1.264-3.866a1 1 0 00-.363-1.118L2.586 9.293c-.784-.57-.38-1.81.588-1.81h4.065a1 1 0 00.95-.69l1.264-3.866z" />
                            </svg>
                        ))}
                    </div>
                    <span className="text-gray-800 ml-2">
                        {feedback.rating.toFixed(1)}
                    </span>
                </div>

                {/* Feedback text */}
                <p className="text-gray-700 text-sm leading-relaxed">
                    {feedback.comments}
                </p>
            </div>
        </div>
    );
}

export default AdminProductFeedbackCard;
